<template>
  <div class="advantage-contain">
    <!-- 项目优势 -->
    <div class="advantage" :style="{ backgroundImage: `url(${item.img})`}">
      <div class="contain">
        <ai2 class="ai2"></ai2>
      </div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
import Ai2 from '@/components/Ai2.vue'

export default {
  name: 'Advantage',
  props: [],
  data: () => ({
    item: {}
  }),
  components: {
    Ai2
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  methods: {
    // 获取手工位
    getHandWork () {
      const hid = this.deviceType === 'pc' ? 4123 : 4116
      XHR.getHandWork({
        type: 8,
        hid: hid
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.item = data[0]
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.advantage {
  position: relative;
  width: 100%;
  height: 650px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  .ai2 {
    position: absolute;
    right: -200px;
    top: 360px;
    bottom: 0;
  }
}

@media screen and (min-width: 376px) {
  .advantage-contain {
    width: 100%;
    height: 802px;
    background-color: #2e64e4;

    .advantage {
      position: relative;
      max-width: 1920px;
      width: 100%;
      width: auto;
      height: 802px;
      margin: auto;
      .contain {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        .ai2 {
          position: relative;
          right: unset;
          top: unset;
          bottom: 0;
        }
      }
    }
  }
}
</style>
